import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("g", { fill: "currentColor" }, [
      createElementVNode("path", { d: "M7.52 16.82a.3.3 0 0 0 0-.22.26.26 0 0 0-.2-.1H4a1 1 0 0 1-1-1v-12a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v11.63a.24.24 0 0 0 .19.24 4.7 4.7 0 0 1 2.39 1.56.25.25 0 0 0 .27.05.25.25 0 0 0 .15-.23V2.5A2.51 2.51 0 0 0 21.5 0h-19A2.51 2.51 0 0 0 0 2.5v14A2.5 2.5 0 0 0 2.5 19h4.75a.25.25 0 0 0 .2-.09.28.28 0 0 0 0-.22 3.7 3.7 0 0 1 .07-1.87" }),
      createElementVNode("path", { d: "M13.62 24a1 1 0 0 1-.77-.36l-3.5-4.22a1.5 1.5 0 1 1 2.3-1.92L14 20.32v-9.83a1.5 1.5 0 0 1 3 0V17h3a4 4 0 0 1 4 4v2a1 1 0 0 1-1 1Z" })
    ], -1)
  ]));
}
const computerDeviceMobileTabletTouch = { render };
export {
  computerDeviceMobileTabletTouch as default,
  render
};
//# sourceMappingURL=computer-device-mobile-tablet-touch.svg.js.map
